import React from 'react';

import { Desktop, Mobile } from '../../Common/const';

class ResourcesHeader extends React.Component {
  render() {
    return (
      <div>
        <Desktop>
          <div className="resources-header-container pt-5 pl-4 pb-5">
            Resources for you.
          </div>
          <div className="gradient-divider" />
        </Desktop>
        <Mobile>
          <div className="gradient-divider" />
        </Mobile>
      </div>
    );
  }
}

export default ResourcesHeader;
